import { render, staticRenderFns } from "./AppLayoutLinks.vue?vue&type=template&id=52e419ef&scoped=true"
import script from "./AppLayoutLinks.vue?vue&type=script&lang=js"
export * from "./AppLayoutLinks.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutLinks.vue?vue&type=style&index=0&id=52e419ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e419ef",
  null
  
)

export default component.exports